<div
    [cdkMenuTriggerFor]="menus"
    (click)="handleOpen($event)"
    class="flex flex-col gap-2 cursor-default"
>
    @if (label() && mode() !== "button") {
        <app-label [required]="required()" [size]="size()">{{
            label()
        }}</app-label>
    }
    <div (clickOutside)="open.set(false)" class="flex relative flex-col gap-1">
        @if (mode() === "button") {
            <app-button
                variant="outline"
                [color]="value()?.length ? 'primary' : 'gray'"
            >
                <div class="flex gap-2 items-center">
                    <p class="text-sm">{{ label() }}</p>
                    @if (value()?.length; as length) {
                        <p
                            class="p-1 py-0 text-sm rounded-md bg-primary-50 aspect-square"
                        >
                            {{ length }}
                        </p>
                    }
                </div>
            </app-button>
        } @else {
            <app-input
                [size]="size()"
                (keyup)="handleKeyup($event)"
                (valueChange)="handleSearch($event)"
                [(value)]="inputValue"
                [readonly]="!search() || isMobile()!"
                [placeholder]="placeholder()"
                [debounce]="search() ? 300 : 0"
                [suffixIcon]="suffixIcon() || 'ic:baseline-keyboard-arrow-down'"
                [prefixIcon]="prefixIcon()"
                [disabled]="disabled()"
            />
        }
    </div>
    @if (showSelectedItems()) {
        <div class="flex flex-wrap gap-2 items-center">
            @for (item of value(); track $index) {
                <app-multiple-select-selected-item
                    [bindLabel]="bindLabel()!"
                    [bindValue]="bindValue()!"
                    (remove)="handleRemove(item)"
                    [options]="options()"
                    [value]="item"
                />
            }
        </div>
    }
</div>

<ng-template #menus>
    @if (open() && options()!.length > 0) {
        <app-menu class="w-full" cdkMenu [class.invisible]="!menuRender()">
            <div class="px-2 w-full">
                @for (option of options(); track option) {
                    <app-multiple-select-option
                        class="w-full"
                        cdkMenuItem
                        (select)="handleSelect($event)"
                        (mouseEnter)="currentIndex.set($index)"
                        (mouseLeave)="currentIndex.set(-1)"
                        [option]="option"
                        [focus]="currentIndex() === $index"
                        [renderItem]="renderItem()"
                        [currentValue]="value()!"
                        [bindLabel]="bindLabel()!"
                        [bindValue]="bindValue()!"
                    />
                } @empty {
                    <div class="p-2 text-center text-gray-400">
                        No results found
                    </div>
                }
            </div>
        </app-menu>
    }
</ng-template>
